import { render } from "./ConfigurationSkippedToast.vue?vue&type=template&id=29563f34"
import script from "./ConfigurationSkippedToast.vue?vue&type=script&lang=js"
export * from "./ConfigurationSkippedToast.vue?vue&type=script&lang=js"
script.render = render

export default script